// src/store/slices/userLineApplicationParametersSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as con from "../../GlobalConstants";
import * as sf from "./../logic/supportFunctions"
import { extractErrorMessage } from "../../utils/errorFunctions";
import { createError } from "../../templates/notifications/Notifications";


// =========================
// Async Thunk
// =========================

export const fetchUserLineApplicationParameters = createAsyncThunk(
  "userLineApplicationParameters/fetch",
  async (_, { rejectWithValue }) => {
    try {

      const config = sf.getRequestConfig()

      let url = con.rest_base_url + con.user_line_application_parameters_api;

      if (sf.surrogateActive()) {
        url = con.rest_base_url + con.staff_user_line_application_parameters_api;
      }

      url = url + `${sf.getCurrentLine()}/`;

      const res = await axios.get(url, config);
      
      const data = res.data[con.SELECTED_BAND_COMPARISON_SCENARIOS]

      return data;

    } catch (err) {
      return rejectWithValue(extractErrorMessage(err, "Error cargando parámetros de la línea"));
    }
  }
);

// EXPORT USER LINE APPLICATION PARAMETERS
export const exportUserLineApplicationParameters = createAsyncThunk(
  "userLineApplicationParameters/export",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();

      // Extract slice safely
      const userLineParams =
        state[con.REDUCER_USER_LINE_APPLICATION_PARAMETERS];

      // Clone to avoid mutating Redux state
      const data = { ...userLineParams };

      // Auth & context
      const user = sf.getUser();

      data[con.USER] = user[con.ID];
      data[con.USER_LINE] = sf.getCurrentLine();


      if (sf.surrogateActive()) {
        const surrogate = sf.getSurrogateUser();

        data[con.SURROGATE_USER] = surrogate[con.ID];
        data[con.USER] = surrogate[con.ID];

      }

      // Build URL

      const url = sf.surrogateActive()
        ? con.rest_base_url + con.staff_user_line_application_parameters_api + `${sf.getCurrentLine()}/`
        : con.rest_base_url + con.user_line_application_parameters_api + `${sf.getCurrentLine()}/`;

      const config = sf.getRequestConfig()

      await axios.put(url, data, config);

      return true;

    } catch (err) {
      return rejectWithValue(extractErrorMessage(err, "Error guardando parámetros de la línea"));
    }
  }
);

// =========================
// Initial State
// =========================

const initialState = {
  [con.SELECTED_BAND_COMPARISON_SCENARIOS]: [
      "SCENARIO_VAR_UP",
      "SCENARIO_VAR_DOWN",
      "HISTORICO_CAIDA_2007",
      "HISTORICO_COVID_2020",
    ],
  [con.USER_LINE_APPLICATION_PARAMETERS_FETCHED]: con.NOT_STARTED,

};

// =========================
// Slice
// =========================

const userLineApplicationParametersSlice = createSlice({
  name: con.REDUCER_USER_LINE_APPLICATION_PARAMETERS,
  initialState,

  reducers: {
    resetUserLineApplicationParameters: () => initialState
  },

  extraReducers: (builder) => {

    builder

      // ===== FETCH =====
      .addCase(fetchUserLineApplicationParameters.pending, (state) => {
        state[con.USER_LINE_APPLICATION_PARAMETERS_FETCHED] = con.LOADING;
      })
      .addCase(fetchUserLineApplicationParameters.fulfilled, (state, action) => {

        state[con.USER_LINE_APPLICATION_PARAMETERS_FETCHED]  = con.OK;

        if (action.payload && Object.keys(action.payload).length > 0) {
          state[con.SELECTED_BAND_COMPARISON_SCENARIOS] = action.payload;
        }
      })
      .addCase(fetchUserLineApplicationParameters.rejected, (state, action) => {
        state[con.USER_LINE_APPLICATION_PARAMETERS_FETCHED]  = con.ERROR;
        createError(action.payload);
      })

      // ===== EXPORT =====
      .addCase(exportUserLineApplicationParameters.pending, (state) => {
        state[con.USER_LINE_APPLICATION_PARAMETERS_FETCHED] = con.LOADING;
      })
      .addCase(exportUserLineApplicationParameters.fulfilled, (state) => {
        state[con.USER_LINE_APPLICATION_PARAMETERS_FETCHED] = con.OK;
      })
      .addCase(exportUserLineApplicationParameters.rejected, (state, action) => {
        state[con.USER_LINE_APPLICATION_PARAMETERS_FETCHED] = con.ERROR;
        createError(action.payload);
      })
  },
});

export const {
  resetUserLineApplicationParameters,
} = userLineApplicationParametersSlice.actions;


export default userLineApplicationParametersSlice.reducer;